import { render, staticRenderFns } from "./TwoFactorAuthenticationDisabled.vue?vue&type=template&id=007ad492&"
import script from "./TwoFactorAuthenticationDisabled.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports